<section class="leagues-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="leagues-page__actions">
      <button class="admin-btn admin-btn--primary" (click)="createLeague()">Nova Liga</button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>
  <div class="admin-feedback admin-feedback--success" *ngIf="feedbackSuccess">
    {{ feedbackSuccess }}
  </div>

  <div class="leagues-toolbar admin-surface">
    <input
      type="text"
      class="admin-input"
      [(ngModel)]="searchTerm"
      placeholder="Buscar por nome, owner ou public_id"
      (keydown.enter)="onSearch()" />

    <select class="admin-input" [(ngModel)]="statusFilter" (change)="onSearch()">
      <option value="">Todos os status</option>
      <option value="DRAFT">Rascunho</option>
      <option value="PUBLISHED">Publicada</option>
      <option value="IN_PROGRESS">Em Progresso</option>
      <option value="FINISHED">Finalizada</option>
      <option value="CANCELED">Cancelada</option>
      <option value="ERROR">Erro</option>
    </select>

    <select class="admin-input" [(ngModel)]="typeFilter" (change)="onSearch()">
      <option value="">Todos os tipos</option>
      <option value="DAILY">Daily</option>
      <option value="SERIES">Series</option>
    </select>

    <div class="leagues-toolbar__actions">
      <button class="admin-btn admin-btn--primary" (click)="onSearch()">Filtrar</button>
      <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="leagues-table admin-surface">
    <p-table
      [value]="leagues"
      [paginator]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalItems"
      [lazy]="true"
      [loading]="isLoading"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Liga</th>
          <th>Owner</th>
          <th>Status</th>
          <th>Início</th>
          <th>Entrada</th>
          <th>Participantes</th>
          <th>Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-league>
        <tr>
          <td>#{{ league.id }}</td>
          <td>
            <button class="league-link" (click)="detailLeague(league.id)">
              <strong>{{ league.name }}</strong>
              <small>{{ league.public_id }}</small>
            </button>
          </td>
          <td>{{ league.owner?.username || '-' }}</td>
          <td>{{ league.status_display || league.status }}</td>
          <td>{{ league.starts_at | date : 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ league.entry_cost | number : '1.0-0' }}</td>
          <td>{{ league.total_participants || 0 }}</td>
          <td>
            <div class="league-actions">
              <button class="admin-btn admin-btn--secondary" (click)="editLeague(league.id)">Editar</button>
              <button
                class="admin-btn admin-btn--primary"
                [disabled]="league.status === 'PUBLISHED' || league.status === 'IN_PROGRESS'"
                (click)="publishLeague(league)">
                Publicar
              </button>
              <button
                class="admin-btn admin-btn--danger"
                [disabled]="league.status === 'CANCELED'"
                (click)="cancelLeague(league)">
                Cancelar
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
